import React, { useEffect, useState } from "react";
import axios from "axios";
import cx from "classnames";
import MenuPage from "./menu.page";
import styles from "./order.module.scss";
import { useNavigate } from "@reach/router";
import NumberFormat from "react-number-format";
import ItemComponent from "./item.component";
import toast, { Toaster } from "react-hot-toast";
import ItemTotalComponent from "../components/item-total/item-total.component";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import ClientComponent from "../components/client/client.component";
import QrComponent from "../components/qr/qr.component";
import html2canvas from "html2canvas";
import { editDelivery } from "../services/delivery.service";
import { ORDER_STATUS, DELIVERY_STATUS, KOT_STATUS, USER_ID } from "../constants/order";

export default function OrderPage({ id, type }) {
  const [order, setOrder] = useState([]);
  const [points, setPoints] = useState([]);
  const [address, setAddress] = useState(undefined);
  const [addressObj, setAddressObj] = useState(undefined);
  const [delivery, setDelivery] = useState(undefined);
  const [orderCurrent, setOrderCurrent] = useState([]);
  const [placements, setPlacements] = useState([]);
  const [kots, setKots] = useState([]);
  const [orderSeq, setOrderSeq] = useState(0);
  const [menu, setMenu] = useState(false);
  const [pickUp, setPickUp] = useState(false);
  const [pickUpObj, setPickUpObj] = useState(undefined);
  const [client, setClient] = useState(false);
  const [ownDelivery, setOwnDelivery] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const [newLead, setNewLead] = useState(false);
  const [enableQR, setEnableQR] = useState(false);
  const [placement, setPlacement] = useState(undefined);
  const [complete, setComplete] = useState(false);
  const [copying, setCopying] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [description, setDescription] = useState("");
  const [kotDescription, setKotDescription] = useState("");
  const [_client, _setClient] = useState(undefined);
  const [clientObj, setClientObj] = useState(undefined);
  const [orderId, setOrderId] = useState(undefined);
  const [orderStatus, setOrderStatus] = useState(undefined);
  const screenshot = React.useRef(null);

  const api = process.env.REACT_APP_API;
  const navigate = useNavigate();
  const [item, setItem] = useState(undefined);

  const close = () => {
    setMenu(false);
  };

  const closeMenu = () => {
    setMenu(false);
    setItem(undefined);
  };

  const guardar = (cat) => {
    if (order.length === 0) {
      if (type === "edit") {
        const promise = axios
          .post(`${api}kot/order/edit`, {
            order: id,
            business: process.env.REACT_APP_BUSINESS,
            description: description,
            total: total,
            placement: placement === "" ? undefined : placement,
            pickUp: pickUp,
            ownDelivery: ownDelivery,
            transfer: transfer,
            newLead: newLead,
            user: USER_ID,
          })
          .then(({ data }) => {
            navigate(`/`);
          });

        toast.promise(promise, {
          loading: "Actualizando...",
          success: "Actualizado correcto!",
          error: "Uh oh, there was an error!",
        });
      }
    } else {
      if (type === "edit") {
        let kotTotal = 0;

        let items = order.map((or) => {
          if (or.total) {
            kotTotal += or.total;
          }

          return {
            qty: or.qty,
            item: or.item,
            instructions: or.instructions,
            description: "",
            discount: parseInt(or.discount),
            total: or.total,
          };
        });

        const promise = axios
          .post(`${api}kot/add`, {
            order: id,
            description: description,
            kotDescription: kotDescription,
            total: kotTotal,
            orderTotal: total,
            items: items,
            placement: placement === "" ? undefined : placement,
            pickUp: pickUp,
            ownDelivery: ownDelivery,
            transfer: transfer,
            newLead: newLead,
            business: process.env.REACT_APP_BUSINESS,
            user: USER_ID,
          })
          .then(({ data }) => {
            navigate(`/`);
          });

        toast.promise(promise, {
          loading: "Actualizando...",
          success: "Actualizado correcto!",
          error: "Uh oh, there was an error!",
        });
      } else {
        let clientExist = "60fb76e1d07a080007af0060";
        if (_client && _client.value) {
          clientExist = _client.value;
        }
        const promise = axios
          .post(`${api}kot/order/add`, {
            business: process.env.REACT_APP_BUSINESS,
            description: description,
            kotDescription: kotDescription,
            total: total,
            source: "xolos menu",
            items: order.map((or) => {
              return {
                qty: or.qty,
                item: or.item,
                instructions: or.instructions,
                description: "",
                discount: parseInt(or.discount),
                total: or.total,
              };
            }),
            placement: placement === "" ? undefined : placement,
            pickUp: pickUp,
            ownDelivery: ownDelivery,
            transfer: transfer,
            newLead: newLead,
            user: USER_ID,
            client: clientExist,
            delivery: addressObj ? true : false,
            address: addressObj,
          })
          .then(({ data }) => {
            navigate(`/`);
          });

        toast.promise(promise, {
          loading: "Guardando...",
          success: "Guardado correcto!",
          error: "Uh oh, there was an error!",
        });
      }
    }
  };

  const completed = () => {
    let body = {
      id: id,
      status: ORDER_STATUS.COMPLETED,
      transfer: transfer,
      newLead: newLead,
      pickUp: pickUp,
      placement: placement === "" ? undefined : placement,
    };

    axios.post(`${api}order/edit/status`, body).then(({ data }) => {
      navigate(`/`);
    });
  };

  const onRoad = async (delivery) => {
    if (window.confirm("Esta seguro que la orden esta en camino?")) {
    }

    try {
      await editDelivery({
        status: DELIVERY_STATUS.ON_ROAD,
        id: delivery._id,
        user: USER_ID,
      });
      toast.success("Orden en camino");
    } catch (error) {
      toast.error("Error al actualizar la orden");
    } finally {
      refresh();
    }
  };

  const readyForPickup = async () => {
    if (!window.confirm("¿Está seguro que la orden está lista para ser recogida?")) {
      return;
    }

    const promise = axios
      .post(`${api}order/edit/status`, {
        id: id,
        status: ORDER_STATUS.READY_FOR_PICKUP,
        transfer: transfer,
        newLead: newLead,
        pickUp: pickUp,
        placement: placement === "" ? undefined : placement,
      })
      .then(({ data }) => {
        refresh();
      });

    toast.promise(promise, {
      loading: "Actualizando...",
      success: "Orden lista para recoger!",
      error: "Error al actualizar la orden",
    });
  };

  const remove = (obj, orderObj) => {
    let temp = [...order];
    let newTotal;
    let priceObj = 0;

    if (orderObj.item.extraPrice) {
      priceObj = orderObj.item.extraPrice * orderObj.qty;
    } else {
      priceObj = orderObj.item.price * orderObj.qty;
    }

    newTotal = total - priceObj;

    setSubTotal(newTotal);
    temp.splice(obj, 1);
    setOrder(temp);
  };

  const removeKot = (kot) => {
    const promise = axios
      .post(`${api}kot/delete`, {
        id: kot._id,
        order: id,
        total: total - kot.total,
      })
      .then(({ data }) => {
        refresh();
      });

    toast.promise(promise, {
      loading: "Eliminando Comanda...",
      success: "Eliminación correcta!",
      error: "Uh oh, there was an error!",
    });
  };

  const completeKot = (kot) => {
    if (
      window.confirm(
        `Esta seguro que desea cambiar el estado de esta comanda ?`
      ) !== true
    ) {
      return;
    }

    const promise = axios
      .post(`${api}kot/edit`, {
        id: kot._id,
        status: kot.status === KOT_STATUS.DELIVERED ? KOT_STATUS.PENDING : KOT_STATUS.DELIVERED,
      })
      .then(() => console.log("entregada"));
    toast
      .promise(promise, {
        loading: "Actualizando...",
        success: "Comanda Actualizando!",
        error: "Uh oh, there was an error!",
      })
      .finally(() => {
        refresh();
      });
  };

  const copyImage = async () => {
    // setCopying(true);
    screenshot.current.classList.add(styles.hideButtons);
    const promise = navigator.clipboard.write([
      // eslint-disable-next-line no-undef
      new ClipboardItem({
        "image/png": getImage(),
      }),
    ]);

    toast
      .promise(promise, {
        loading: "Copiando...",
        success: "Copiado correctamente!",
        error: "Uh oh, there was an error!",
      })
      .finally(() => {
        setCopying(false);
        screenshot.current.classList.remove(styles.hideButtons);
      });
  };

  const getImage = async () => {
    const canvas = await html2canvas(document.querySelector("#screenshot"));
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      });
    });
    return blob;
  };

  useEffect(() => {
    if (type) {
      refresh();
    }
  }, []);

  useEffect(() => {
    if (client === false) {
      _setClient(undefined);
      setAddressObj(undefined);
      setAddress(undefined);
    }
  }, [client]);

  useEffect(() => {
    const _placements = localStorage.getItem("placements");
    if (_placements) {
      setPlacements(JSON.parse(_placements));
    }
  }, []);

  useEffect(() => {
    setPlacement("");
  }, [pickUp, ownDelivery]);

  const refresh = () => {
    axios.get(`${api}order/getOne/${id}`).then(({ data }) => {
      setOrderId(data._id);
      setDescription(data.description ? data.description : "");
      setOrderSeq(data.id);
      setKots(data.kot);
      setPoints(data.points);
      setTransfer(data.transfer ? data.transfer : false);
      setNewLead(data.newLead ? data.newLead : false);
      setPickUp(data.isPickUp ? data.isPickUp : false);
      setPickUpObj(data.pickUp ? data.pickUp : undefined);
      setOwnDelivery(data.isOwnDelivery ? data.isOwnDelivery : false);
      setPlacement(data.placement ? data.placement : "");
      setClient(data.client ? true : false);
      setDelivery(data.delivery);
      setOrderStatus(data.status?._id);
      if (data.client) {
        _setClient({
          value: data.client._id,
          label: `${data.client.name}${
            data.client.phone ? " - " + data.client.phone : ""
          }`,
        });
      }
      let newOrder = [];
      let totalEdit = 0;

      if (data.status.name !== "Completada") {
        setComplete(true);
      }

      data.items.map((item) => {
        let price = 0;
        let calc = 0;
        if (item.item.extraPrice) {
          calc = item.qty * item.item.extraPrice;
        } else {
          calc = item.qty * item.item.price;
        }

        if (item.discount) {
          calc = calc * (1 - (item.discount * 1) / 100);
        }
        totalEdit = totalEdit + calc;
        newOrder.push({
          qty: item.qty,
          item: item.item,
          descripcion: item.description,
          instructions: item.instructions,
          discount: item.discount,
          total: calc,
        });
      });

      data.kot.forEach((_kot) => {
        _kot.items.forEach((item) => {
          let calc = 0;
          if (item.item.extraPrice) {
            calc = item.qty * item.item.extraPrice;
          } else {
            calc = item.qty * item.item.price;
          }

          if (item.discount) {
            calc = calc * (1 - (item.discount * 1) / 100);
          }
          totalEdit = totalEdit + calc;
        });
      });
      setSubTotal(totalEdit);
      setOrderCurrent(newOrder);
    });
  };

  const changeAddress = (obj) => {
    if (obj) {
      setAddressObj({
        ...obj,
        contactAddress: obj._id,
      });
      setAddress(obj._id);
      setDelivery(obj);
    } else {
      setAddress(undefined);
    }
  };

  const changeQR = (id) => {
    setEnableQR(true);
  };

  useEffect(() => {
    if (delivery) {
      let price = delivery.price ?? delivery.single_address?.price;
      setTotal(subTotal + price);
    } else {
      setTotal(subTotal);
    }
  }, [subTotal, delivery]);

  return (
    <div>
      <div className={cx(styles.order)}>
        <div className={styles.orderSeq}>
          #{orderSeq && orderSeq}
          <span className={styles.rightButtons}>
            <button onClick={() => changeQR(order._id)}>QR</button>
            <button onClick={() => copyImage()}>Captura</button>
          </span>
        </div>
        <div className={styles.orderDetalle}>
          <div
            id="screenshot"
            ref={screenshot}
            className={cx(styles.screenshot, copying && styles.copy)}
          >
            <div
              className={cx(styles.orderItem, styles.orderHeader, styles.edit)}
            >
              <div className="qty">QTY</div>
              <div className="producto">Producto</div>
              <div className="total">Total</div>
              <div className={styles.action}></div>
            </div>
            {order.map((or, i) => {
              return (
                <div
                  className={cx(styles.orderItem, styles.edit)}
                  key={`${i}-order`}
                >
                  <div className={styles.qty}>{or.qty}</div>
                  <div className={styles.producto}>
                    <div className={styles.name}>{or.item.name}</div>
                    {or.item.selectedAttributes &&
                      or.item.selectedAttributes.map((attribute, i) => {
                        if (attribute.value) {
                          let tempText =
                            or.item.attributes.length > 0 &&
                            or.item.attributes.find(
                              (list) => list._id === attribute._id
                            );

                          return (
                            <span key={attribute._id}>
                              <b>{tempText ? tempText.title : ""}</b>:{" "}
                              {attribute.childValue.title}
                              {attribute.childValue.description && (
                                <span className={styles.attributeDescription}>
                                  [{attribute.childValue.description}]
                                </span>
                              )}
                            </span>
                          );
                        } else if (attribute.multiple?.length > 0) {
                          let multipleText = "";
                          let text = "";
                          let tempText =
                            or.item.attributes.length > 0 &&
                            or.item.attributes.find(
                              (list) => list._id === attribute._id
                            );

                          attribute.multiple.map((m, i) => {
                            if (i == 0) {
                              multipleText = m.title;
                            } else {
                              multipleText = multipleText + " · " + m.title;
                            }
                          });

                          return (
                            <span key={attribute._id}>
                              <b>{tempText ? tempText.title : ""}</b>:
                              {multipleText}
                            </span>
                          );
                        }
                      })}

                    {or.instructions && (
                      <span key={or.item._id}>
                        <b>{"Instrucciones"}</b>: {or.instructions}
                      </span>
                    )}
                  </div>
                  <div className={styles.total}>
                    <NumberFormat
                      value={or.total}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </div>
                  <div className={styles.action}>
                    <div
                      className="button-icon remove"
                      onClick={remove.bind(null, i, or)}
                    >
                      <i className="fas fa-trash-alt"></i>
                    </div>
                  </div>
                </div>
              );
            })}
            {order.length > 0 && <hr />}
            {orderCurrent.map((or, i) => {
              return (
                <div
                  className={cx(styles.orderItem, styles.edit)}
                  key={`${i}-order`}
                >
                  <div className={styles.qty}>{or.qty}</div>
                  <div className={styles.producto}>
                    <div className={styles.name}>{or.item.name}</div>
                    {or.item.selectedAttributes &&
                      or.item.selectedAttributes.map((attribute, i) => {
                        if (attribute.value) {
                          let tempText =
                            or.item.attributes.length > 0 &&
                            or.item.attributes.find(
                              (list) => list._id === attribute._id
                            );

                          return (
                            <span key={attribute._id}>
                              <b>{tempText ? tempText.title : ""}</b>:{" "}
                              {attribute.childValue.title}
                              {attribute.childValue.description && (
                                <span className={styles.attributeDescription}>
                                  [{attribute.childValue.description}]
                                </span>
                              )}
                            </span>
                          );
                        } else if (attribute.multiple) {
                          let multipleText = "";
                          let text = "";
                          let tempText =
                            or.item.attributes.length > 0 &&
                            or.item.attributes.find(
                              (list) => list._id === attribute._id
                            );
                          attribute.multiple.map((m, i) => {
                            if (i == 0) {
                              multipleText = m.title;
                            } else {
                              multipleText = multipleText + " · " + m.title;
                            }
                          });
                          return (
                            <span key={attribute._id}>
                              <b>{tempText ? tempText.title : ""}</b>:{" "}
                              {multipleText}
                            </span>
                          );
                        }
                      })}

                    {or.instructions && (
                      <span key={or.item._id}>
                        <b>{"Instrucciones"}</b>: {or.instructions}
                      </span>
                    )}
                  </div>
                  <div className={styles.total}>
                    <NumberFormat
                      value={or.total}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </div>
                  <div className={styles.action}>
                    <div
                      className="button-icon remove"
                      onClick={remove.bind(null, i, or)}
                    >
                      <i className="fas fa-trash-alt"></i>
                    </div>
                  </div>
                </div>
              );
            })}
            {points?.length > 0 && (
              <div>
                <h3 className={styles.pointsTitle}>Productos con Puntos</h3>
                {points.map((point, i) => {
                  return (
                    <div key={i} className={cx(styles.orderItem, styles.edit)}>
                      <div className={styles.qty}>-</div>
                      <div className={styles.producto}>
                        <div className={styles.name}>{point.name}</div>
                      </div>
                      <div className={styles.total}>{point.price}</div>
                    </div>
                  );
                })}
              </div>
            )}
            {kots.map((kot, i) => {
              return (
                <React.Fragment key={kot._id}>
                  <div className={styles.kotHeader}>
                    <h3
                      className={cx(
                        styles.status,
                        kot.status === KOT_STATUS.PENDING
                          ? styles.pending
                          : styles.complete
                      )}
                    >
                      <span>Comanda {i + 1}:</span>
                      {kot.status === KOT_STATUS.PENDING ? "Pendiente" : "Completada"}
                    </h3>
                    <div className={cx(styles.buttons)}>
                      <div
                        className={cx(
                          styles.btnComplete,
                          kot.status !== KOT_STATUS.PENDING && styles.reset
                        )}
                        onClick={() => completeKot(kot)}
                      >
                        {kot.status !== KOT_STATUS.PENDING ? (
                          <i className="fas fa-times"></i>
                        ) : (
                          <i className="fas fa-check"></i>
                        )}
                      </div>
                      <div
                        className={styles.btnRemove}
                        onClick={() => removeKot(kot)}
                      >
                        <i className="fas fa-trash-alt"></i>
                      </div>
                    </div>
                  </div>
                  {kot.items.map((or, i) => {
                    return (
                      <div className={cx(styles.orderItem)} key={`${i}-order`}>
                        <div className={styles.qty}>{or.qty}</div>
                        <div className={styles.producto}>
                          <div className={styles.name}>{or.item.name}</div>
                          {or.item.selectedAttributes &&
                            or.item.selectedAttributes.map((attribute, i) => {
                              if (attribute.value) {
                                let tempText =
                                  or.item.attributes.length > 0 &&
                                  or.item.attributes.find(
                                    (list) => list._id === attribute._id
                                  );

                                return (
                                  <span key={attribute._id}>
                                    <b>{tempText ? tempText.title : ""}</b>:{" "}
                                    {attribute.childValue.title}
                                    {attribute.childValue.description && (
                                      <span
                                        className={styles.attributeDescription}
                                      >
                                        [{attribute.childValue.description}]
                                      </span>
                                    )}
                                  </span>
                                );
                              } else if (attribute.multiple) {
                                let multipleText = "";
                                let text = "";
                                let tempText =
                                  or.item.attributes.length > 0 &&
                                  or.item.attributes.find(
                                    (list) => list._id === attribute._id
                                  );
                                attribute.multiple.map((m, i) => {
                                  if (i == 0) {
                                    multipleText = m.title;
                                  } else {
                                    multipleText =
                                      multipleText + " · " + m.title;
                                  }
                                });
                                return (
                                  <span key={attribute._id}>
                                    <b>{tempText ? tempText.title : ""}</b>:{" "}
                                    {multipleText}
                                  </span>
                                );
                              }
                            })}

                          {or.instructions && (
                            <span key={or.item._id}>
                              <b>{"Instrucciones"}</b>: {or.instructions}
                            </span>
                          )}
                        </div>
                        <div className={styles.total}>
                          <ItemTotalComponent order={or} />
                        </div>
                      </div>
                    );
                  })}
                  <div className={styles.kotDescription}>{kot.description}</div>
                </React.Fragment>
              );
            })}
            {delivery && (
              <div
                className={cx(
                  styles.orderItem,
                  styles.orderFooter,
                  styles.edit,
                  type === "edit" && styles.deliveryRow
                )}
              >
                <div className="qty"></div>
                <div className={styles.producto}>Envío</div>
                <div className={styles.totalEnvio}>
                  <NumberFormat
                    value={delivery.price ?? delivery.single_address?.price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    fixedDecimalScale={true}
                    decimalScale={2}
                  />
                </div>
                <div className="actio"></div>
              </div>
            )}
            <div
              className={cx(styles.orderItem, styles.orderFooter, styles.edit)}
            >
              <div className="qty"></div>
              <div className={styles.producto}></div>
              <div className={styles.total}>
                <NumberFormat
                  value={total}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              </div>
              <div className="actio"></div>
            </div>

            <div className={styles.abacco}>https://abacco.magga.dev/</div>
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="" style={{ width: "100%" }}>
              Indicaciones Comanda
            </label>
            <input
              type="text"
              className="form-control"
              value={kotDescription}
              onChange={(e) => setKotDescription(e.target.value)}
              placeholder="Ej. Agregar chiles toreados"
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="" style={{ width: "100%" }}>
              Indicaciones Especiales Generales
            </label>
            <input
              type="text"
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Ej. Pago dividido"
            />
          </div>
          {!pickUp && !ownDelivery && (
            <div className={styles.formGroup}>
              <label>Mesa</label>
              <select
                value={placement}
                onChange={(e) => setPlacement(e.target.value)}
              >
                <option value="">Seleccionar</option>
                {placements.map((placement) => {
                  return (
                    <option key={placement._id} value={placement._id}>
                      {placement.name}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          <div className={styles.formGroup}>
            <label className={styles.inputCheckbox}>
              <input
                name="isGoing"
                type="checkbox"
                checked={pickUp}
                onChange={(e) => setPickUp(e.target.checked)}
              />
              Para llevar
            </label>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.inputCheckbox}>
              <input
                name="isGoing"
                type="checkbox"
                checked={ownDelivery}
                onChange={(e) => setOwnDelivery(e.target.checked)}
              />
              Delivery Propio
            </label>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.inputCheckbox}>
              <input
                name="isGoing"
                type="checkbox"
                checked={client}
                disabled={type === "edit" || type === "view" ? true : false}
                onChange={(e) => setClient(e.target.checked)}
              />
              Cliente
            </label>
          </div>
          {client && (
            <ClientComponent
              client={_client}
              setClient={_setClient}
              setClientObj={setClientObj}
              changeAddress={changeAddress}
              address={address}
              setAddressObj={setAddressObj}
              type={type}
              delivery={delivery}
            />
          )}
          <div className={styles.formGroup}>
            <label className={styles.inputCheckbox}>
              <input
                name="isGoing"
                type="checkbox"
                checked={transfer}
                onChange={(e) => setTransfer(e.target.checked)}
              />
              Pago con Tarjeta o Transferencia
            </label>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.inputCheckbox}>
              <input
                name="isGoing"
                type="checkbox"
                checked={newLead}
                onChange={(e) => setNewLead(e.target.checked)}
              />
              Cliente Nuevo
            </label>
          </div>
        </div>
      </div>
      <div className={styles.floating}>
        {!type && (
          <div className={styles.save} onClick={() => guardar()}>
            Guardar
          </div>
        )}
        {complete && pickUpObj?.personPhone && orderStatus !== ORDER_STATUS.READY_FOR_PICKUP && (
          <div className={styles.readyForPickup} onClick={() => readyForPickup()}>
            Listo para Recoger
          </div>
        )}
        {complete && (
          <div className={styles.update} onClick={() => guardar()}>
            Actualizar
          </div>
        )}
        {complete && (
          <div className={styles.complete} onClick={() => completed()}>
            Completar
          </div>
        )}
        {delivery?.status?._id === DELIVERY_STATUS.PENDING && (
          <div className={styles.onRoad} onClick={() => onRoad(delivery)}>
            En Camino
          </div>
        )}
        <div className={styles.addProduct} onClick={() => setMenu(true)}>
          Agregar Producto
        </div>
        <div
          className={styles.close}
          onClick={() => {
            navigate(`/`);
          }}
        >
          Salir
        </div>
      </div>
      {menu && (
        <MenuPage
          close={close}
          setOrder={setOrder}
          order={order}
          setTotal={setSubTotal}
          total={subTotal}
          setItem={setItem}
        />
      )}
      {item && (
        <ItemComponent
          product={item}
          setOrder={setOrder}
          order={order}
          setTotal={setSubTotal}
          total={subTotal}
          close={closeMenu}
        />
      )}
      {enableQR && (
        <QrComponent value={orderId} close={() => setEnableQR(false)} />
      )}
    </div>
  );
}
